module.exports = __webpack_public_path__ + "img/logo-paliari.0e97b332.png";